const prefix = "kredo";
const displayName = "Kredo";

const icons = Object.entries(import.meta.glob("./*.vue")).reduce(
	(acc, [path, component]) => {
		const componentName = `${prefix}:${path.match(/\/([^/]+)\.vue$/)[1]}`;
		acc[componentName] = defineAsyncComponent(() => component());
		return acc;
	},
	{}
);
const iconsArray = Object.keys(icons);
const iconsSet = new Set(iconsArray);

export default {
	prefix,
	name: displayName,
	isIconFromSet: (name) => iconsSet.has(name),
	getComponent: (name) => icons[name],
	getArray: () => iconsArray,
};
